import { defineStore } from "pinia";
import { IParamsNps, IUserNpsStore } from "./types";
import { EStepsPesquisa } from "@/components/PesquisaNPS/types";

export const idStore = "userPesquisaNps";

export const usePesquisaNpsStore = defineStore(idStore, {
  state: (): IUserNpsStore => ({
    params: {
      nota: undefined,
      comentario: "",
      campanhaId: "",
      cliente: "",
      tipoCampanha: 0,
      exibirCampanha: false,
      step: EStepsPesquisa.escolherNota
    }
  }),
  actions: {
    setNota(value: number | undefined): void {
      this.params.nota = value;
    },
    setComentario(value: string): void {
      this.params.comentario = value;
    }
  },
  getters: {
    obterCampanhaParams(): IParamsNps {
      return this.params;
    }
  }
});
